import React from "react";
import { Row, Col, InputNumber, Switch } from "antd";

const SectionHeader = () => (
  <Row gutter={16} className="mb-2">
    <Col span={10} />
    <Col span={4} className="text-center">
      <span className="text-muted small">偵測啟動</span>
    </Col>
    <Col span={10} />
  </Row>
);

const EnableRow = ({ label, description, enabledKey, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label className="font-weight-bold">{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} className="text-center">
      <Switch
        checked={fields[enabledKey]}
        onChange={(v) => setField(enabledKey, v)}
      />
    </Col>
    <Col span={10} />
  </Row>
);

const FieldRow = ({ label, description, fieldKey, min, max, step, unit, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label>{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} />
    <Col span={10}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        value={fields[fieldKey]}
        onChange={(v) => setField(fieldKey, v)}
        addonAfter={unit}
      />
    </Col>
  </Row>
);

const ProtectionZoneConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <SectionHeader />

    <EnableRow
      label="防護區入侵偵測"
      description="未授權人員進入防護區時觸發警報"
      enabledKey="protection_zone_enabled"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="警報冷卻時間"
      description="同一人員同一防護區的重複警報間隔"
      fieldKey="protection_zone_cooldown_seconds"
      min={60}
      max={86400}
      step={60}
      unit="秒"
      fields={fields}
      setField={setField}
    />
  </div>
);

export default ProtectionZoneConfig;
